import '../../assets/cssFiles/index_page.css'

import React, { Component } from 'react';

import IndexItemTitle from '../../components/IndexItemTitle';
import IndexItemBox from '../../components/IndexItemBox';
import CarouselComponent from '../../components/CarouselComponent';
import Popup from '../../components/Popup';

export default  class IndexPage extends Component{

    constructor(props){
        super(props);
        this.state={
            showVideoPopup: false,
            showImgLook: false,
            showImgName: ""
        }
    }
    
    setImgLookState=(boolean=false,e={})=>{
        if(boolean){
            this.setState({
                showImgLook: true,
                showImgName: e.nativeEvent.target.src
            })
        }else{
            this.setState({
                showImgLook: false,
                showImgName: ''
            })
        }
    }

    componentDidMount(){
        //以下代码用于处理在safari浏览器下友情链接因为浏览器差异导致的高度和其他浏览器不一致问题
        const isSafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);;
        if(isSafariBrowser){
            document.querySelector('.left').firstElementChild.style.marginTop = "127px";
        }
    }

    render(){
        const objArr = [{ imgName: 'index_banner_1.jpg', toUrl: ''},{ imgName: 'index_banner_2.jpg', toUrl: ''}];
        const indexItemsArr = [{ imgName: 'service_1.png', content: '高中生生涯规划和<br/>高考升学的贴心顾问'},{ imgName: 'service_2.png', content: '高中学校生涯规划教育<br/>信息化的拓荒者'},{ imgName: 'service_3.png', content: '高中和高校沟通的桥梁<br/>'}];
        const indexServiceImgArr = ["service_img_1.png","service_img_2.png","service_img_3.png","service_img_4.png"]
        return(
            <React.Fragment>
                <div className="page index-container relative">
                    <CarouselComponent classNameProp="carousel-wrapper" options={objArr} showDots="true" playVideo={()=>{this.setState({showVideoPopup: true})}}/>
                    <div className="container section1">
                        <IndexItemTitle title="我们的优势" subTitle="PREPONDERANCE" height={197}/>
                        <div className="flex-rank">
                            <img className="div-img-translateY-10" src={require('../../assets/images/advantage_img_1.jpg')}/>
                            <img className="div-img-translateY-10" src={require('../../assets/images/advantage_img_2.png')}/>
                            <img className="div-img-translateY-10" src={require('../../assets/images/advantage_img_3.png')}/>
                        </div>
                        <div className="section1-title"><span className="biger">更懂</span>新高考，<span className="biger">更全</span>大数据，<span className="biger">八年</span>实践经验</div>
                    </div>
                    <div className="section2">
                        <IndexItemTitle title="我们的服务" subTitle="SERVICE" height={186} bc="#cedee4"/>
                        <div className="container">
                            <div className="section2-top-item">
                                {indexItemsArr.map((item,index)=>(<IndexItemBox key={index} imgName={item.imgName} content={item.content}/>))}
                            </div>
                            <div className="flex-rank">
                                {indexServiceImgArr.map((item,index)=>(
                                    <img key={index} onClick={(e)=>{this.setImgLookState(true,e)}} className="hand div-img-scale1-1" style={{width: '24%',height: "24%"}} src={require(`../../assets/images/${item}`)}/>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="section3">
                        <IndexItemTitle title="联系我们" subTitle="CONTACT US" height={215}/>
                        <div className="container">
                            <img className="section-logo" src={require('../../assets/images/bottom_logo.png')}/>
                            <div className="section-info">
                                <div><span style={{fontSize: 34}}>0571 -88383709</span>（周一至周五: 8:30-17:00）</div>
                                <div className="line-height-38">浙江省杭州市钱塘区白杨街道科技园支路65号和达高科创新服务中心3楼</div>
                                <div className="line-height-38">更多新高考相关内容、服务、直播尽在“选考在线”</div>
                            </div>
                            <img className="section-logo2" src={require('../../assets/images/bottom_logo2.png')}/>
                        </div>
                    </div>
                </div>
                <Popup isShow={this.state.showVideoPopup} clickMask={()=>{this.setState({showVideoPopup: false})}}>
                    <video autoPlay ref="media" controls controlsList="nodownload" src="https://hal-static.oss-cn-qingdao.aliyuncs.com/video/index_video.mp4"></video>
                </Popup>
                <Popup isShow={this.state.showImgLook} clickMask={()=>{this.setImgLookState()}}>
                    <img src={this.state.showImgName}/>
                </Popup>
            </React.Fragment>
        )
    }
}
